import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UserModule } from './user/user.module';
import { SsoComponent } from './sso/sso.component';
import { AuthGuard } from './user/services/auth-guard';
import { LoginComponent } from './user/login/login.component';
import { AuditTrailComponent } from './dashboard/audit-trail/audit-trail.component';
import { AddUserComponent } from './dashboard/add-user/add-user.component';
import { UserSessionComponent } from './dashboard/user-session/user-session.component';

const routes: Routes = [
  {
    path: 'user',
    loadChildren: () => UserModule
  },
  {
    path : 'dashboard',
    canActivate: [AuthGuard],
    loadChildren :() => 
      import('./dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  { 
    path: '',
    redirectTo: 'user',
    pathMatch: 'full'
  },
  { 
    path: 'sso',
    children: [
      {
        path: "**",
        component: SsoComponent
      }
    ],
  },
  { 
    canActivate: [AuthGuard],
    path: 'audit',
    component: AuditTrailComponent
  },
  { 
    canActivate: [AuthGuard],
    path: 'audit',
    component: AddUserComponent
  },
  { 
    canActivate: [AuthGuard],
    path: 'audit',
    component: UserSessionComponent
  },
  { 
    path: '**',
    component: LoginComponent
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash:true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
